import React from 'react';
import { Button,Checkbox,message } from 'antd';
import { addContentPath } from '../../../util/pathUtil';

class E9Form extends React.Component {
    constructor(props) {
        super(props);
        this.getLoginForm = this.getLoginForm.bind(this);
        this.onLabelClick = this.onLabelClick.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.getDynamicPassword = this.getDynamicPassword.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }

    componentDidMount() {
        const { loginstate = {}} = this.props;
        const { cacheAccount: loginId, langId } = loginstate;
        this.props.getLoginForm({ loginId, langId });
    }

    componentDidUpdate() {
        const { loginFormDataLoading } = this.props;
        if (loginFormDataLoading) {
            this.props.doAfterLoginRenderEvent();
        }

        const _this = this;
        jQuery('.e9login-pop-form-input').unbind().keydown(function (e) {
            e = e || window.event;
            const key = e.keyCode || e.which || e.charCode;
            if (key == 13) {
                const inputs = jQuery('.e9login-pop-form-input');
                const idx = inputs.index(this);
                const nxtIdx = idx + 1;
                const nxtInput = jQuery(`.e9login-pop-form-input:eq(${nxtIdx})`);
                if (nxtInput.length > 0) {
                    nxtInput.focus();
                } else {
                    _this.onLogin();
                }
            }
        });
    }

    render() {
        const {  loginstate, dynamicPasswordTime }=this.props;
        const {
            isLogging,
            isRememberPW,
            isRememberAccount,
            isRememberPassword,
            cacheAccount,
            cachePassword,
            loginFormItems,
            loginFormHiddenItems,
            loginSetting = {},
            validateCode,
            labelInfo,
            langId,
        } = loginstate;
        let labelObj=labelInfo[`langid${langId}`] || {};        
        const { needforgotpassword, validateCodeKey = '' } = loginSetting;       
        const validateCodeSrc = `${validateCode}&validateCodeKey=${validateCodeKey}`;
        return (
            <div className="e9login-pop-form">
                {
                    loginFormItems.map((item, index) => {
                        let defaultValue = '';
                        if (item.atype == 'account') {
                            defaultValue = cacheAccount;
                        } else if (item.atype == 'password') {
                            defaultValue = cachePassword;
                        }

                        let itemComp = (
                            <div key={index} className="e9login-pop-form-item" >
                                <i className={`icon-coms-${item.atype == 'account' ? 'yonghu' : 'locking'}`} />
                                <label className={`e9login-pop-form-label ${defaultValue ? 'e9login-pop-display-hidden' : ''}`} onClick={this.onLabelClick}>{item.label}</label>
                                <input type={item.type} id={item.id} name={item.name} autoComplete="new-password" className="e9login-pop-form-input" defaultValue={defaultValue} onBlur={ () => { item.atype == 'account' && this.getLoginForm()}} onChange={this.onInputChange} 
                                />
                            </div>
                        );

                        if (item.atype == 'dynamicPassword') {
                            itemComp = (
                                <div key={index} className="e9login-pop-form-item" >
                                    <i className="icon-coms-locking" />
                                    <label className="e9login-pop-form-label" onClick={this.onLabelClick}>{item.label}</label>
                                    <input type={item.type} id={item.id} name={item.name} autoComplete="new-password" className="e9login-pop-form-input" onChange={this.onInputChange} />
                                    <div className="e9login-pop-form-dynamic" >
                                        {
                                            dynamicPasswordTime > 0 ? (
                                                <span className="e9login-pop-form-dynamic-text">
                                                    {labelObj.resend}({dynamicPasswordTime}s)
                                                </span>
                                                ) : (
                                                <span className="e9login-pop-form-dynamic-text" onClick={this.getDynamicPassword}>
                                                    {labelObj.send}
                                                </span>
                                                )
                                        }
                                    </div>
                                </div>
                            );
                        }
                        if (item.atype == 'validatecode') {
                            itemComp = (
                                <div key={index} className="e9login-pop-form-item" >
                                    <i className="icon-coms02-verification-code" />
                                    <label className="e9login-pop-form-label e9login-pop-form-label-vc" onClick={this.onLabelClick}>{item.label}</label>
                                    <input type={item.type} id={item.id} name={item.name} className="e9login-pop-form-input e9login-pop-form-input-vc" onChange={this.onInputChange} />
                                    <div className="e9login-pop-form-vc-img">
                                        <img src={addContentPath(validateCodeSrc)} alt="" onClick={this.props.onValidateCodeChange} />
                                    </div>
                                </div>
                            );
                        }

                        return itemComp;
                    })
                }
                {
                    loginFormHiddenItems.map((item, index) => <div key={index}  dangerouslySetInnerHTML={{ __html: item.html }} />)
                }
                <div className="e9login-pop-form-remember" >
                    {
                        needforgotpassword == '1' && (
                            <div className="e9login-pop-form-remember-forget" title={labelObj.forgetPassword}>
                                <span onClick={() => this.props.onPasswordForget()}>{labelObj.forgetPassword}</span>
                            </div>
                        )
                    }
                    <div className={`e9login-pop-form-remember-content ${isRememberPW == '1' ? '' : 'e9login-pop-display-hidden'}`}>
                        <div className={'e9login-pop-form-remember-account'} title={labelObj.rememberAccount}>
                            <Checkbox  checked={isRememberAccount} onChange={e => this.props.onRememberChange('account', e.target.checked)}>{labelObj.rememberAccount}</Checkbox>
                        </div>
                        <div className={'e9login-pop-form-remember-password'} title={labelObj.rememberPassword}>
                            <Checkbox  checked={isRememberPassword} onChange={e => this.props.onRememberChange('password', e.target.checked)}>{labelObj.rememberPassword}</Checkbox>
                        </div>
                    </div>
                    <div className="e9login-pop-form-clear" />
                </div>
                <div className="e9login-pop-form-submit">
                    <Button type="primary" loading={isLogging} id="submit" name="submit" className="e9login-pop-form-submit-btn" onClick={this.onLogin}>
                        {labelObj.login}
                    </Button>
                </div>
            </div>
        );
    }

    getLoginForm() {
        this.props.getLoginForm({}, (result = {}) => {
            const { loginSetting = {}, message: warningMsg } = result;
            const { userUsbType } = loginSetting;
            if (userUsbType == '6') {
                warningMsg && message.warning(warningMsg);
                this.props.setStateAndCache('loginType', 'QRCode');
            }
        });
    }

    onLabelClick(e) {
        jQuery(e.target.parentNode).find('input').focus();
    }

    onInputChange(e) {
        if (e.target.value) {
            jQuery(e.target.parentNode).find('.e9login-pop-form-label').addClass('e9login-pop-display-hidden');
        } else {
            jQuery(e.target.parentNode).find('.e9login-pop-form-label').removeClass('e9login-pop-display-hidden');
        }
    }

    getDynamicPassword() {
        this.props.getDynamicPassword();
    }

    onLogin() {
        this.props.onLogin();
    }
}

export default E9Form;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-login-pop/e9login/E9Form.js